import { INFLUENCER_INTERESTED_SUCCESS } from '../constants';

const initState = {
  deals: []
};

const dealsReducer = (state = initState, action) => {
  switch (action.type) {
    case INFLUENCER_INTERESTED_SUCCESS:
      return {
        ...state
      };
    default:
      return state;
  }
};

export default dealsReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/dealsReducer.js